module.exports = __webpack_public_path__ + "images/173_1024.jpg";